import React from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';

// One card per ManufacturingLine (a machine configuration): for an offset_pair, a printing machine + a
// die-cutting machine; for a flexo_combined, a single combined printing_and_die_cutting_machine. Styled
// like the solution cards. Solutions for the manufacturingLine are searched once it is selected — onSelect.
const ManufacturingLineCard = ({ manufacturingLine, onSelect }) => {
  const formatSheet = (width, height) => {
    if (!width || !height) {
      return null;
    }
    return `${Math.round(parseFloat(width))}mm X ${Math.round(parseFloat(height))}mm`;
  };

  const machineColumn = (label, machineName, sheet) => (
    <div className={styles.layout_column} style={{ display: 'flex', flexDirection: 'column' }}>
      <div className={styles.layout_column_label}>{label}</div>
      <div className={styles.dimension_text}>
        <strong>{machineName}</strong>
      </div>

      {sheet && (
        <div style={{ marginTop: 'auto' }}>
          <div className={styles.dimension_label}>{t('quote_builder.machine_dimensions')}</div>
          <div className={styles.dimension_text}>{sheet}</div>
        </div>
      )}
    </div>
  );

  const dieCuttingSheet = formatSheet(manufacturingLine.sheet_width_mm, manufacturingLine.sheet_height_mm);
  const printingSheet = formatSheet(manufacturingLine.printing_sheet_width_mm, manufacturingLine.printing_sheet_height_mm);

  const machineColumns = () => {
    if (manufacturingLine.type === 'flexo_combined') {
      return machineColumn(
        `${t('quote_builder.cutting')} + ${t('layouts.layout_type_printing')}`,
        manufacturingLine.printing_and_die_cutting_machine_label,
        dieCuttingSheet
      );
    }

    return (
      <>
        {machineColumn(t('quote_builder.cutting'), manufacturingLine.die_cutting_machine_label, dieCuttingSheet)}
        {machineColumn(t('layouts.layout_type_printing'), manufacturingLine.printing_machine_label, printingSheet)}
      </>
    );
  };

  const handleClick = () => {
    if (onSelect) {
      onSelect(manufacturingLine);
    }
  };

  return (
    <div className={styles.combinations_grid_item_cont} data-manufacturing-line-identifier={manufacturingLine.identifier} onClick={handleClick}>
      <div className={styles.combinations_grid_item}>
        <div className={styles.layout_columns_container}>
          {machineColumns()}
        </div>
      </div>
    </div>
  );
};

export default ManufacturingLineCard;
